function customPromisse<T>(defaultValue: T) {
  return new Promise<T>((resolve) => resolve(defaultValue));
}

function maskCpf() {
  return '999.999.999-99'
}

function maskCnpj() {
  return '99.999.999/9999-99'
}

function maskCellphone() {
  return '(99) 99999-9999'
}

function maskPhone() {
  return '(99) 9999-9999'
}

function maskCep() {
  return '99999-999'
}


function generateGuid() {
  function uuidv4() {
    // eslint-disable-next-line no-mixed-operators
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      // eslint-disable-next-line no-mixed-operators
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      // eslint-disable-next-line no-mixed-operators
      return v.toString(16);
    });
  }
  return uuidv4();
}

function formatBytes(bytes: number, decimals = 2) {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}

function selectInputFiles(files: File[], save: Function) {
  if (files.length === 0) return;

  let finalFiles: any[] = [];

  files.forEach(file => {
    let fileReader = new FileReader();

    let onLoadFunction = (fileLoadedEvent: any) => {
      const srcData = fileLoadedEvent.target.result;

      let finalFile = {
        ...file, id: 0,
        srcData,
        preview: URL.createObjectURL(file),
        formattedSize: Helper.formatBytes(file.size),
        isImage: isImage(file.name),
        name: removeExtention(file.name)
      }

      finalFiles.push(finalFile);

      if (finalFiles.length === files.length)
        save(finalFiles);
    };
    fileReader.onload = onLoadFunction;
    fileReader.readAsDataURL(file);
  })
}

function selectInputFileImage(fileSelected: Function) {
  const extentions = 'image/jpeg,image/jpg,image/png';
  const input = document.createElement("input");
  input.setAttribute('type', 'file');
  input.setAttribute('accept', extentions);
  input.addEventListener('change', (event: any) => {
    const curFiles = event?.target?.files as File[] | null;
    if (!curFiles)
      return;
    selectInputFiles(Array.from(curFiles), fileSelected);
  });
  input.click();
}

function selectInputFile(fileSelected: Function, extentions: string) {
  const input = document.createElement("input");
  input.setAttribute('type', 'file');
  input.setAttribute('accept', extentions);
  input.addEventListener('change', (event: any) => {
    const curFiles = event?.target?.files as File[] | null;
    if (!curFiles)
      return;
    selectInputFiles(Array.from(curFiles), fileSelected);
  });
  input.click();
}

function isImage(url: string) {
  return ['png', 'jpg', 'jpeg', 'tiff'].some(x => x === url.split('.')[url.split('.').length - 1]?.toLocaleLowerCase());
}

function removeExtention(fileName: string) {
  return fileName.split('.')[0];
}

const downloadFile = (response: any, filename = 'Relatorio') => {
  if (response == null)
    return;
  try {
    try {
      let contentDisposition = response.headers["content-disposition"];
      let match = contentDisposition.match(/filename\s*=\s*"(.+)"/i);
      filename = match[1];
    } catch (error) {

    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
  } catch (error) {

  }
}

function downloadURI(uri: string, name: string) {
  var link = document.createElement("a");
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}



function filterArray(filter: string, array: any[], key: string) {
  return filter.length > 0 ? array.filter(c => c[key]?.toLowerCase().indexOf(filter.toLowerCase()) !== -1) : array;
}


const cloneObject = (obj: any) => {
  let copy: any;

  // Handle the 3 simple types, and null or undefined
  if (null == obj || "object" != typeof obj) return obj;

  // Handle Date
  if (obj instanceof Date) {
    copy = new Date();
    copy.setTime(obj.getTime());
    return copy;
  }

  // Handle Array
  if (obj instanceof Array) {
    copy = [];
    for (var i = 0, len = obj.length; i < len; i++) {
      copy[i] = cloneObject(obj[i]);
    }
    return copy;
  }

  // Handle Object
  if (obj instanceof Object) {
    copy = {};
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = cloneObject(obj[attr]);
    }
    return copy;
  }

  throw new Error("Unable to copy obj! Its type isn't supported.");
}

function unifiedDataEzeeSolar(data: any) {
  return data.reduce((acc: any, item: any) => {
    if (item.group === 2) {
      // Verifica se já criamos o item unificado
      const existingUnified = acc.find((i: any) => i.id === 2);

      if (!existingUnified) {
        // Cria o novo item unificado
        acc.push({
          id: 2,
          name: 'Ezee Solar',
          group: 2,
          image: item.image, // Pode escolher uma das imagens ou uma nova
          order: 2, // Mantém a ordem do primeiro item
          active: true,
          titleColor: item.titleColor,
          subTitleColor: item.subTitleColor,
          originalItems: data.filter((i: any) => i.group === 2) // Mantém referência aos originais
        });
      }
    } else {
      // Adiciona outros itens normalmente
      acc.push(item);
    }

    return acc;
  }, [])
}

const fileToBase64 = async (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Remove o prefixo "data:*/*;base64," do resultado
      const base64String = (reader.result as string).split(',')[1];
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });
};

const getLinkForNotification = (not: any) => {
  if (Number(not.typeKey ?? 0) === 1) {
    if (not.valueInfoKey) {
      return `/proposal-detail/${not.valueInfoKey}`;
    } else {
      if (not.body) {
        const listitensDesc = not.body.split(' ') ?? '';
        if (listitensDesc != '') {
          if (listitensDesc.length > 1 && listitensDesc[1].includes("P-")) {
            return `/proposal-detail/${listitensDesc[1]}`;
          } else if (listitensDesc[0].includes("P-")) {
            return `/proposal-detail/${listitensDesc[0]}`;
          } else {
            return '/my-proposal'
          }
        } else {
          return '/my-proposal'
        }
      } else {
        return '/my-proposal'
      }
    }
  }
  return '/my-proposal'
}
const isSafari = () => {
  const ua = navigator.userAgent;
  const isChrome = /Chrome/.test(ua) && /Google Inc/.test(navigator.vendor);
  const isSafari = /Safari/.test(ua) && !isChrome;
  return isSafari;
};

const handleScroll = (id: string, direction: 'left' | 'right', pixels: number = 65) => {
  const element = document.getElementById(id)
  if (!element)
    return

  switch(direction){
    case 'left':
      element.scrollLeft -= pixels;
      break;
    case "right":
      element.scrollLeft += pixels
      break
  }
}

const Helper = {
  customPromisse,
  maskCpf,
  maskCnpj,
  maskCellphone,
  maskPhone,
  maskCep,
  generateGuid,
  formatBytes,
  selectInputFiles,
  selectInputFileImage,
  isImage,
  downloadFile,
  filterArray,
  downloadURI,
  selectInputFile,
  cloneObject,
  unifiedDataEzeeSolar,
  fileToBase64,
  getLinkForNotification,
  isSafari,
  handleScroll
}

export default Helper;
